export default "__VITE_ASSET__CjHS$W_s__"